// extracted by mini-css-extract-plugin
module.exports = {"contact-table":"Seller_contact-table__2jVQi"};